import { IconButton, Tooltip } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useCart } from '../../contexts/CartContext';
import { Link } from 'react-router-dom';

const CartIconButton = () => {
    const { cartItemsTotal } = useCart();

    return (
        <Link color="inherit" to="/cart">
            <Tooltip title="Cart">
                <IconButton>
                    <ShoppingCartIcon />
                </IconButton>
            </Tooltip>
            {cartItemsTotal && (
                <span style={{ marginLeft: 5 }}>{cartItemsTotal}</span>
            )}
        </Link>
    );
};

export default CartIconButton;
